export function FigmaFormIcon() {
  return (
    <svg className="inline-block" width="24" height="24" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.667 9.417a2.583 2.583 0 0 0 0 5.166h2.583V9.417H8.667Zm2.583-1.5H8.667a2.584 2.584 0 0 1 0-5.167h2.583v5.167Zm1.5-5.167v5.167h2.583a2.584 2.584 0 0 0 0-5.167H12.75Zm2.583 6.666a2.583 2.583 0 0 0-2.583 2.542v.083a2.583 2.583 0 1 0 2.583-2.625Zm-6.666 6.667a2.584 2.584 0 1 0 2.583 2.584v-2.584H8.667Z"
        className="dark:fill-white light:fill-black"
        fillOpacity="0.5"
      />
    </svg>
  );
}
